@if (toast()) {
    <div
        class="tw:fixed tw:bottom-5 tw:min-w-[280px] tw:left-1/2 tw:z-[9999] tw:-translate-x-1/2 tw:transform tw:rounded-lg tw:px-4 tw:py-2 tw:text-white tw:shadow-lg tw:transition-all tw:duration-500"
        [ngClass]="{
            'tw:bg-success-500': toast()?.type === 'success',
            'tw:bg-error-500': toast()?.type === 'error',
            'tw:translate-y-0': isVisible,
            'tw:translate-y-full': !isVisible,
            'tw:opacity-100': isVisible,
            'tw:opacity-0': !isVisible,
        }">
        <div class="tw:flex tw:items-center">
            @if (toast()?.type === "success") {
                <i class="material-icons icon tw:mr-4 tw:mb-1">check_circle</i>
            } @else {
                <i class="material-icons icon tw:mr-4 tw:mb-1">cancel</i>
            }
            <div class="tw:text-sm tw:mb-0">{{ toast()?.message }}</div>
        </div>
    </div>
}
